import { render } from "./ShopBackPayment.vue?vue&type=template&id=972d06f0"
import script from "./ShopBackPayment.vue?vue&type=script&lang=js"
export * from "./ShopBackPayment.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__